import ApprovalCard from '../chat/ApprovalCard';
import { getApprovals, errorText } from '../api';
import { useLoad } from '../fmt';

// Everything waiting for the boss, from every employee (prototype scene 17).
export default function Approvals({ agentsById, onBack, onDecide, version }) {
  const { data, error, loading } = useLoad(() => getApprovals('pending'), [version]);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div className="vh">
        <div><h2>Approvals</h2><p>Nothing below is saved or sent until you approve it.</p></div>
        <button className="aio-btn" onClick={onBack}>Back to office</button>
      </div>
      {error && <div className="err">{errorText(error)}</div>}
      {!error && (data || !loading) && (
        <div className="aplist">
          {data && data.length
            ? data.map((item) => <ApprovalCard key={item.id} item={item} agent={agentsById[item.agentId]} onDecide={onDecide} />)
            : <div className="panel empty">All clear. Nothing is waiting for you.</div>}
        </div>
      )}
    </div>
  );
}
